<template>
    <main class="quiz container">
        수정 후 '엔터키'를 눌러서 '저장' 버튼을 활성화 하세요.
        <editable-quizzes></editable-quizzes>
    </main>
</template>

<style scoped>
</style>

<script>
import { mapState } from 'vuex'
import EditableQuiz from '@/components/quiz/EditableQuiz'
import EditableQuizzes from '../components/quiz/EditableQuizzes'

export default {
  name: 'Quiz',

  created () {
    this.$store.dispatch('setMode', 'TEST')
    this.$store.dispatch('quizzes/bindQuizOfToday')
  },

  mounted () {
  },

  beforeDestory () {
    this.unbind()
  },

  beforeRouteLeave (to, from, next) {
    this.unbind()
    next()
  },

  data () {
    return {}
  },

  computed: {
    ...mapState('quizzes', [
      'quizOfToday'
    ])
  },

  methods: {
    unbind () {
      this.$store.dispatch('quizzes/unbindQuizOfToday')
    }
  },

  components: {
    EditableQuizzes,
    EditableQuiz
  }
}
</script>
